import { SheetEvent } from '@/types/sheetEvents';
import { PretensionReportTableHistoryRow } from '@/utils/pretensionsReportDisplay';

export type ChangedByDisplayKind = 'unknown' | 'auto' | 'email';

export interface ChangedByDisplay {
  kind: ChangedByDisplayKind;
  email: string | null;
}

// Паттерн согласован с backend (pretensions/src/Core/Action.php getChangedByFromRequest):
// тот же ASCII-only набор символов. Любой email, не подходящий под backend regex,
// в БД попадает как 'system' (fallback) — frontend никогда не получит unicode email
// в поле changedBy. Не ослаблять без синхронной правки backend.
const EMAIL_PATTERN = /^[a-z0-9._+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
const ISO_DATE_PATTERN = /^(\d{4}-\d{2}-\d{2})/;

// changedAtIso приходит из PHP в формате ATOM ('2026-04-12T10:23:45+03:00').
// Дата (первые 10 символов) сравнима лексикографически с since='YYYY-MM-DD'.
export function isLegacyRecord(changedAtIso: string, since: string | null): boolean {
  if (!since) return false;
  const m = ISO_DATE_PATTERN.exec(changedAtIso);
  if (!m) return false;
  return m[1] < since;
}

export function displayChangedBy(
  changedBy: string | null,
  changedAt: string,
  since: string | null,
): ChangedByDisplay {
  if (changedBy === null) return { kind: 'unknown', email: null };
  if (changedBy === 'system') {
    return isLegacyRecord(changedAt, since)
      ? { kind: 'unknown', email: null }
      : { kind: 'auto', email: null };
  }
  if (EMAIL_PATTERN.test(changedBy)) {
    return { kind: 'email', email: changedBy };
  }
  return { kind: 'unknown', email: null };
}

export type HistoryRow = PretensionReportTableHistoryRow & { actor: ChangedByDisplay };

export interface HistoryItem {
  key: string;
  time: number;
  row?: HistoryRow;
  event?: SheetEvent;
}

/** Переходы статусов и события претензии одной лентой, новые сверху. */
export function mergeHistory(rows: Array<HistoryRow>, events: Array<SheetEvent>): Array<HistoryItem> {
  const time = (v: string | null): number => (v ? new Date(v).getTime() || 0 : 0);
  return [
    ...rows.map((row, i) => ({ key: `s${i}`, time: time(row.changedAtIso), row })),
    ...events.map((event) => ({ key: `e${event.id}`, time: time(event.occurred_at), event })),
  ].sort((a, b) => b.time - a.time);
}
